var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.stateValue,
        expression: "stateValue",
      },
    ],
    staticClass: "music-player-progress",
    style: { backgroundSize: `${_vm.percentage}% 100%` },
    attrs: { type: "range", step: "1", min: "0", max: _vm.max },
    domProps: { value: _vm.stateValue },
    on: {
      mousedown: _vm.onMouseDown,
      touchstart: _vm.onMouseDown,
      mouseup: _vm.onMouseUp,
      touchend: _vm.onMouseUp,
      mousemove: _vm.onMouseMove,
      __r: function ($event) {
        _vm.stateValue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }